export const accountLink = [
  {
    title: "Account",
    link: "/account",
  },
  {
    title: "Address",
    link: "/account/address",
  },
  {
    title: "Orders",
    link: "/account/orders",
  },
  {
    title: "Wishlist",
    link: "/account/wishlist",
  },
];
